











import { Component, Prop, Vue } from "vue-property-decorator";
import HomeSection from "../home/HomeSection.vue";

@Component({
  components: { HomeSection },
})
export default class LegalPageLayout extends Vue {
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) content!: string;

  get hasContent() {
    return this.content !== null && this.content !== undefined && this.content !== "";
  }
}
